import { WS2_AMENITY_NAMES, WS2_AMENITY_SLUGS } from '../../constants/amenities';

function EditedBadge() {
    return (
        <span className="inline-flex items-center gap-1 rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-blue-700">
            Edited
        </span>
    );
}

function arraysEqual(a, b) {
    if (!a || !b) return false;
    return a.length === b.length && [...a].sort().join() === [...b].sort().join();
}

export default function AmenitiesChipEditor({
    value = [],
    onChange,
    onAddAmenity,
    onRemoveAmenity,
    aiSuggested = null,
    edited: editedProp,
    disabled = false,
}) {
    if (value === null) return null;

    const edited = editedProp ?? (aiSuggested != null && !arraysEqual(value, aiSuggested));
    const available = WS2_AMENITY_SLUGS.filter((s) => !value.includes(s));

    const handleAdd = (slug) => {
        if (!slug) return;
        if (onChange) {
            onChange([...value, slug]);
        } else {
            onAddAmenity?.(slug);
        }
    };

    const handleRemove = (slug) => {
        if (onChange) {
            onChange(value.filter((s) => s !== slug));
        } else {
            onRemoveAmenity?.(slug);
        }
    };

    return (
        <div>
            <div className="mb-2.5 flex items-center gap-2">
                <span className="text-[11px] font-bold uppercase tracking-wider text-gray-500">
                    Amenities
                </span>
                {edited && <EditedBadge />}
            </div>
            <div className="flex flex-wrap gap-1.5">
                {value.map((slug) => (
                    <span
                        key={slug}
                        className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-xs text-gray-800"
                    >
                        {WS2_AMENITY_NAMES[slug] ?? slug}
                        {!disabled && (
                            <button
                                type="button"
                                className="text-sm font-bold leading-none text-gray-400 hover:text-red-500"
                                onClick={() => handleRemove(slug)}
                                aria-label={`Remove ${WS2_AMENITY_NAMES[slug] ?? slug}`}
                            >
                                ×
                            </button>
                        )}
                    </span>
                ))}
                {!disabled && available.length > 0 && (
                    <select
                        className="cursor-pointer rounded-full border border-dashed border-gray-300 bg-white px-3 py-1 text-xs text-gray-500 hover:border-secondary hover:text-secondary"
                        value=""
                        onChange={(e) => {
                            handleAdd(e.target.value);
                            e.target.value = '';
                        }}
                    >
                        <option value="">+ Add amenity</option>
                        {available.map((slug) => (
                            <option key={slug} value={slug}>
                                {WS2_AMENITY_NAMES[slug] ?? slug}
                            </option>
                        ))}
                    </select>
                )}
            </div>
        </div>
    );
}
